module.exports = __webpack_public_path__ + "static/img/china-4.901a790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-4.png
// module id = 1386
// module chunks = 1